module.exports = __webpack_public_path__ + "img/sweetleaf-listo.60ac582a.png";